export const helpCenterContentInCourseViewAdapter = (data) => {
  const createdAt = new Date(data.page.created_at);
  const modifiedAt = new Date(data.page.modified_at);
  const pages = [...data.course.pages.articles, ...data.course.pages.videos, ...data.course.pages.hotkeys].map(
    (item) => ({
      ...item,
      section: data.course.pages_sections.find((section) => section.id === item.section_id).slug,
      category: data.course.pages_subsections.find((subsection) => subsection.id === item.subsection_id).slug,
    })
  );

  return {
    id: data.page.id,
    caption: data.page.caption,
    description: data.page.description,
    meta_title: data.page.meta_title,
    meta_description: data.page.meta_description,
    slug: `${data.page.slug}/?course_id=${data.course.id}`,
    category: data.subsection.slug,
    category_name: data.subsection.caption,
    section: data.section.slug,
    section_name: data.section.caption,
    cover: data.page.cover,
    time: data.page.reading_time,
    page_views: data.page.page_views,
    courses: data.page.courses,
    body: data.page.body,
    createdAt: createdAt.toISOString(),
    modifiedAt: modifiedAt.toISOString(),
    asideNav: pages
      .filter((item) => item.slug.length > 0)
      .map((item) => ({
        caption: item.caption,
        slug: `${item.section}/${item.category}/${item.slug}/?course_id=${data.course.id}`,
        id: item.id,
      })),
    course: {
      sectionSlug: data.course.section.slug,
      sectionCaption: data.course.section.caption,
      courseSlug: data.course.slug,
      courseCaption: data.course.caption,
    },
  };
};
